import React from 'react';
import PropTypes from 'prop-types';
import { Button, CurrencyFormat } from '@lt/components';
import LoaderIcon from '@lt/components/icons-react/rebrand/Loader';
import { useCurrency, useTranslation } from '@lt/localization';

import {
  pluralizeNights,
  pluralizeTouristsAcc,
} from '../../../../utils/pluralizeUtils';

import styles from './searcher.module.css';

const SearcherFixedButton = ({
  price,
  onClick,
  nightsCount,
  touristsCount,
  fetching,
  isHotelOnly,
}) => {
  const { code } = useCurrency();
  const { t } = useTranslation();
  const buttonSubtext = `${t('hotel.fixedButton.subtext', {
    count: `${nightsCount}`,
    nights: `${pluralizeNights(nightsCount)}`,
    countTourist: `${touristsCount}`,
    tourists: `${pluralizeTouristsAcc(touristsCount)}`,
  })} ${isHotelOnly ? `` : t('hotel.fixedButton.withFlight')}`;
  const hasPrice = Boolean(price);

  return (
    <div className={styles.searcherFixedButtonFixedContainer}>
      <Button
        className={styles.searcherFixedButton}
        onClick={onClick}
        functional
      >
        {fetching ? (
          <LoaderIcon className={styles.loader} />
        ) : (
          <>
            {hasPrice ? (
              <>
                <span>
                  {t('hotel.fixedButton.getPrice', {
                    context: isHotelOnly ? 'hotel' : 'package',
                  })}
                </span>
                <CurrencyFormat value={price} currencyCode={code} />
                <div className={styles.searcherFixedButtonText}>
                  {buttonSubtext}
                </div>
              </>
            ) : (
              <span>
                {t('hotel.fixedButton.changeDate', {
                  context: isHotelOnly ? 'hotel' : 'package',
                })}
              </span>
            )}
          </>
        )}
      </Button>
    </div>
  );
};

SearcherFixedButton.propTypes = {
  price: PropTypes.number,
  nightsCount: PropTypes.number.isRequired,
  touristsCount: PropTypes.number.isRequired,
  onClick: PropTypes.func.isRequired,
  fetching: PropTypes.bool,
};

SearcherFixedButton.defaultProps = {
  fetching: false,
  price: null,
};

export default SearcherFixedButton;
